import { makeAutoObservableSuper } from 'shared/lib/mobx/makeAutoObservableSuper'
import { type IResponseContactSalesforceIntegration } from 'entities/Contacts/api/types'
import { ContactIntegrationBase } from 'entities/Contacts/model/Integrations/ContactIntegrationBase'

export class ContactSalesforce extends ContactIntegrationBase<IResponseContactSalesforceIntegration> {
  integration_type: 'salesforce'

  constructor(response: IResponseContactSalesforceIntegration) {
    super(response)

    makeAutoObservableSuper(this)

    this.integration_type = 'salesforce'
    this.email = response.email
    this.national_number = response.phones['Phone'] || ''

    this.phone = this.national_number
    this.mobile_phone = response.phones['Mobile Phone'] || ''
    this.custom_phone = response.phones['Custom Phone'] || ''
  }
}
